import React, { useState, useEffect } from "react"
import axios from "axios"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

const MESES = ["Janeiro","Fevereiro","Março","Abril","Maio","Junho",
               "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"]

export default function FechamentoMensal() {
  const hoje = new Date()
  const [mes, setMes]           = useState(hoje.getMonth()+1)
  const [ano, setAno]           = useState(hoje.getFullYear())
  const [tipoPeriodo, setTipoPeriodo] = useState<"mensal"|"personalizado">("mensal")
  const [dataIni, setDataIni]   = useState(new Date(hoje.getFullYear(),hoje.getMonth(),1).toISOString().split("T")[0])
  const [dataFim, setDataFim]   = useState(new Date(hoje.getFullYear(),hoje.getMonth()+1,0).toISOString().split("T")[0])
  const [clienteId, setClienteId] = useState("")
  const [clientes, setClientes] = useState<any[]>([])
  const [gerando, setGerando]   = useState(false)
  const [preview, setPreview]   = useState<any>(null)
  const [carregando, setCarregando] = useState(false)

  useEffect(()=>{
    axios.get(`${API}/clientes`).then(r=>setClientes(r.data)).catch(()=>{})
  },[])

  // Atualizar datas ao mudar mês/ano
  useEffect(()=>{
    if(tipoPeriodo==="mensal"){
      setDataIni(new Date(ano,mes-1,1).toISOString().split("T")[0])
      setDataFim(new Date(ano,mes,0).toISOString().split("T")[0])
    }
  },[mes,ano,tipoPeriodo])

  const getParams = () => {
    if(tipoPeriodo==="mensal") return {mes:String(mes),ano:String(ano),cliente_id:clienteId}
    // Para personalizado, calcular mês/ano do início
    const dt = new Date(dataIni)
    return {
      mes:String(dt.getMonth()+1), ano:String(dt.getFullYear()),
      data_ini:dataIni, data_fim:dataFim, cliente_id:clienteId
    }
  }

  const buscarPreview = async () => {
    setCarregando(true)
    try {
      const r = await axios.get(`${API}/relatorios/fechamento-mensal`, { params: { ...getParams(), formato:'json' } })
      setPreview(r.data)
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao buscar dados") }
    finally { setCarregando(false) }
  }

  const gerar = async (formato:string) => {
    setGerando(true)
    try {
      const token = localStorage.getItem("moobi_token")||""
      const p = getParams()
      const params = new URLSearchParams()
      Object.entries({...p, formato}).forEach(([k,v])=>{ if(v) params.set(k,String(v)) })
      const r = await fetch(`${API}/relatorios/fechamento-mensal?${params}`,
        {headers:{Authorization:`Bearer ${token}`}})
      const blob = await r.blob()
      const url = URL.createObjectURL(blob)
      const nome = tipoPeriodo==="mensal"
        ? `fechamento_${MESES[mes-1]}_${ano}`
        : `fechamento_${dataIni}_${dataFim}`
      if(formato==="pdf") window.open(url,"_blank")
      else {
        const a=document.createElement("a"); a.href=url
        a.download=`${nome}.xlsx`
        document.body.appendChild(a); a.click(); document.body.removeChild(a)
      }
    } catch { alert("Erro ao gerar relatório") }
    finally { setGerando(false) }
  }

  const fmtMoeda = (v:any) => v!=null ? `R$ ${parseFloat(v).toLocaleString("pt-BR",{minimumFractionDigits:2})}` : "—"

  const tituloPeriodo = tipoPeriodo==="mensal"
    ? `${MESES[mes-1]} / ${ano}`
    : `${new Date(dataIni).toLocaleDateString("pt-BR")} a ${new Date(dataFim).toLocaleDateString("pt-BR")}`

  return (
    <div style={{padding:24,height:"100%",overflowY:"auto"}}>
      <div style={{marginBottom:24}}>
        <h2 style={{fontSize:20,fontWeight:700}}>📅 Fechamento Mensal</h2>
        <p style={{fontSize:13,color:"#64748b"}}>Faturamento com mensalidades, pro rata, instalações e desinstalações</p>
      </div>

      {/* Filtros */}
      <div className="card" style={{marginBottom:20}}>
        <div style={{fontSize:13,fontWeight:700,marginBottom:16}}>🔍 Filtros</div>

        {/* Tipo de período */}
        <div style={{display:"flex",gap:8,marginBottom:16}}>
          {[{id:"mensal",label:"📆 Mês completo"},{id:"personalizado",label:"📅 Período personalizado"}].map(t=>(
            <button key={t.id} onClick={()=>setTipoPeriodo(t.id as any)}
              className={tipoPeriodo===t.id?"btn btn-primary":"btn btn-ghost"}
              style={{fontSize:12}}>
              {t.label}
            </button>
          ))}
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr auto",gap:12,alignItems:"end"}}>
          {tipoPeriodo==="mensal" ? (
            <>
              <div className="form-group" style={{margin:0}}>
                <label>Mês</label>
                <select value={mes} onChange={e=>setMes(parseInt(e.target.value))}>
                  {MESES.map((m,i)=><option key={i+1} value={i+1}>{m}</option>)}
                </select>
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Ano</label>
                <select value={ano} onChange={e=>setAno(parseInt(e.target.value))}>
                  {[2024,2025,2026,2027].map(a=><option key={a} value={a}>{a}</option>)}
                </select>
              </div>
            </>
          ) : (
            <>
              <div className="form-group" style={{margin:0}}>
                <label>Data início</label>
                <input type="date" value={dataIni} onChange={e=>setDataIni(e.target.value)} />
              </div>
              <div className="form-group" style={{margin:0}}>
                <label>Data fim</label>
                <input type="date" value={dataFim} max={new Date().toISOString().split("T")[0]}
                  onChange={e=>setDataFim(e.target.value)} />
              </div>
            </>
          )}

          <div className="form-group" style={{margin:0}}>
            <label>🏢 Cliente</label>
            <select value={clienteId} onChange={e=>setClienteId(e.target.value)}>
              <option value="">Todos os clientes</option>
              {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
            </select>
          </div>

          <button className="btn btn-primary" onClick={buscarPreview} disabled={carregando}>
            {carregando?"⏳":"🔍"} Visualizar
          </button>
        </div>

        <div style={{display:"flex",gap:8,marginTop:16}}>
          <button className="btn btn-primary" onClick={()=>gerar("pdf")} disabled={gerando}
            style={{flex:1,justifyContent:"center"}}>
            {gerando?"⏳ Gerando...":"📄 Gerar PDF"}
          </button>
          <button className="btn btn-ghost" onClick={()=>gerar("excel")} disabled={gerando}
            style={{flex:1,justifyContent:"center"}}>
            {gerando?"⏳ Gerando...":"📊 Gerar Excel"}
          </button>
        </div>
      </div>

      {/* Preview */}
      {preview && (
        <div>
          <div style={{fontSize:14,fontWeight:700,color:"#94a3b8",marginBottom:16}}>
            📊 Resultado — {tituloPeriodo}
            {clienteId && ` · ${clientes.find(c=>c.id===clienteId)?.razao_social}`}
          </div>

          {/* Cards resumo */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:16,marginBottom:20}}>
            {[
              {label:"Ativos faturados", valor:preview.totalAtivos||0, cor:"#0ea5e9", icone:"🚗"},
              {label:"Mensalidades", valor:fmtMoeda(preview.totalMensal), cor:"#22c55e", icone:"💰"},
              {label:"Instalações", valor:fmtMoeda(preview.totalInstalacoes), cor:"#f59e0b", icone:"🔧"},
              {label:"Desinstalações", valor:fmtMoeda(preview.totalDesinstalacoes), cor:"#f87171", icone:"🔓"},
            ].map((s,i)=>(
              <div key={i} className="card" style={{padding:"14px 16px"}}>
                <div style={{fontSize:22,marginBottom:6}}>{s.icone}</div>
                <div style={{fontSize:18,fontWeight:700,color:s.cor}}>{s.valor}</div>
                <div style={{fontSize:11,color:"#64748b"}}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* Total geral */}
          <div style={{background:"#1e3a6e",borderRadius:10,padding:"16px 20px",
            display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
            <div>
              <div style={{fontSize:12,color:"#94a3b8"}}>TOTAL GERAL DO FECHAMENTO</div>
              <div style={{fontSize:11,color:"#64748b",marginTop:2}}>
                Mensalidades {fmtMoeda(preview.totalMensal)} + Instalações {fmtMoeda(preview.totalInstalacoes)} + Desinstalações {fmtMoeda(preview.totalDesinstalacoes)}
              </div>
            </div>
            <div style={{fontSize:28,fontWeight:700,color:"#22c55e"}}>{fmtMoeda(preview.totalGeral)}</div>
          </div>

          {/* Tabela mensalidades */}
          {preview.linhas?.length > 0 && (
            <div className="card" style={{padding:0,overflow:"hidden",marginBottom:16}}>
              <div style={{padding:"12px 16px",fontWeight:700,fontSize:13,borderBottom:"1px solid #2d4166",
                display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <span>💰 Mensalidades ({preview.linhas.length} ativo(s))</span>
                <span style={{fontSize:13,color:"#22c55e",fontWeight:700}}>{fmtMoeda(preview.totalMensal)}</span>
              </div>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead>
                  <tr style={{background:"#0d1b2e"}}>
                    {["Veículo","Placa","Cliente","Período","Dias","Plano 1","Valor 1","Plano 2","Valor 2","Total",""].map(h=>(
                      <th key={h} style={{padding:"8px 12px",textAlign:"left",fontSize:10,
                        color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {preview.linhas.map((l:any,i:number)=>(
                    <tr key={i} style={{borderBottom:"1px solid rgba(45,65,102,0.3)",
                      background:i%2===0?"transparent":"#0d1b2e08"}}>
                      <td style={{padding:"8px 12px",fontSize:12,fontWeight:500}}>{l.nome}</td>
                      <td style={{padding:"8px 12px",fontSize:11,fontFamily:"monospace"}}>{l.placa||"—"}</td>
                      <td style={{padding:"8px 12px",fontSize:11,color:"#94a3b8"}}>{l.cliente_nome||"—"}</td>
                      <td style={{padding:"8px 12px",fontSize:11}}>{l.periodoUso}</td>
                      <td style={{padding:"8px 12px",fontSize:11,color:"#0ea5e9",textAlign:"center"}}>{l.diasUso}/{l.diasMes}</td>
                      {[0,1].map(idx=>(
                        <React.Fragment key={idx}>
                          <td style={{padding:"8px 12px",fontSize:10,color:"#64748b"}}>
                            {l.contratos_list?.[idx]?.plano_nome||"—"}
                          </td>
                          <td style={{padding:"8px 12px",fontSize:11,color:"#22c55e"}}>
                            {l.contratos_list?.[idx] ? fmtMoeda(
                              l.proRata
                                ? (parseFloat(l.contratos_list[idx].valor_mensal||0)/l.diasMes*l.diasUso)
                                : parseFloat(l.contratos_list[idx].valor_mensal||0)
                            ) : "—"}
                          </td>
                        </React.Fragment>
                      ))}
                      <td style={{padding:"8px 12px",fontSize:12,fontWeight:600,color:"#22c55e"}}>{fmtMoeda(l.valorProporcional)}</td>
                      <td style={{padding:"8px 12px"}}>
                        {l.proRata
                          ? <span style={{fontSize:10,background:"#451a03",color:"#fbbf24",padding:"1px 6px",borderRadius:8}}>⚡ Pro rata</span>
                          : ""}
                      </td>
                    </tr>
                  ))}
                  <tr style={{background:"#0c2a4a",borderTop:"2px solid #0ea5e9"}}>
                    <td colSpan={7} style={{padding:"8px 12px",fontSize:12,fontWeight:600,color:"#38bdf8"}}>SUBTOTAL MENSALIDADES</td>
                    <td style={{padding:"8px 12px",fontSize:14,fontWeight:700,color:"#22c55e"}}>{fmtMoeda(preview.totalMensal)}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          )}

          {/* Instalações */}
          {preview.instalacoes?.length > 0 && (
            <div className="card" style={{padding:0,overflow:"hidden",marginBottom:16}}>
              <div style={{padding:"12px 16px",fontWeight:700,fontSize:13,borderBottom:"1px solid #2d4166",
                display:"flex",justifyContent:"space-between"}}>
                <span>🔧 Instalações ({preview.instalacoes.length})</span>
                <span style={{color:"#f59e0b"}}>{fmtMoeda(preview.totalInstalacoes)}</span>
              </div>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead>
                  <tr style={{background:"#0d1b2e"}}>
                    {["Data","Veículo","Placa","Cliente","Custo"].map(h=>(
                      <th key={h} style={{padding:"8px 12px",textAlign:"left",fontSize:10,color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {preview.instalacoes.map((h:any,i:number)=>(
                    <tr key={i} style={{borderBottom:"1px solid rgba(45,65,102,0.3)"}}>
                      <td style={{padding:"8px 12px",fontSize:11}}>{new Date(h.data_evento).toLocaleDateString("pt-BR")}</td>
                      <td style={{padding:"8px 12px",fontSize:12,fontWeight:500}}>{h.ativo_nome}</td>
                      <td style={{padding:"8px 12px",fontSize:11,fontFamily:"monospace"}}>{h.placa||"—"}</td>
                      <td style={{padding:"8px 12px",fontSize:11,color:"#94a3b8"}}>{h.cliente_nome}</td>
                      <td style={{padding:"8px 12px",fontSize:12,color:"#f59e0b",fontWeight:600}}>{fmtMoeda(h.custo)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Desinstalações */}
          {preview.desinstalacoes?.length > 0 && (
            <div className="card" style={{padding:0,overflow:"hidden",marginBottom:16}}>
              <div style={{padding:"12px 16px",fontWeight:700,fontSize:13,borderBottom:"1px solid #2d4166",
                display:"flex",justifyContent:"space-between"}}>
                <span>🔓 Desinstalações ({preview.desinstalacoes.length})</span>
                <span style={{color:"#f87171"}}>{fmtMoeda(preview.totalDesinstalacoes)}</span>
              </div>
              <table style={{width:"100%",borderCollapse:"collapse"}}>
                <thead>
                  <tr style={{background:"#0d1b2e"}}>
                    {["Data","Veículo","Placa","Cliente","Motivo","Custo"].map(h=>(
                      <th key={h} style={{padding:"8px 12px",textAlign:"left",fontSize:10,color:"#64748b",fontWeight:600,textTransform:"uppercase"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {preview.desinstalacoes.map((h:any,i:number)=>(
                    <tr key={i} style={{borderBottom:"1px solid rgba(45,65,102,0.3)"}}>
                      <td style={{padding:"8px 12px",fontSize:11}}>{new Date(h.data_evento).toLocaleDateString("pt-BR")}</td>
                      <td style={{padding:"8px 12px",fontSize:12,fontWeight:500}}>{h.ativo_nome}</td>
                      <td style={{padding:"8px 12px",fontSize:11,fontFamily:"monospace"}}>{h.placa||"—"}</td>
                      <td style={{padding:"8px 12px",fontSize:11,color:"#94a3b8"}}>{h.cliente_nome}</td>
                      <td style={{padding:"8px 12px",fontSize:11,color:"#64748b"}}>{h.observacoes||"—"}</td>
                      <td style={{padding:"8px 12px",fontSize:12,color:"#f87171",fontWeight:600}}>{fmtMoeda(h.custo)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  )
}
